import styled from 'styled-components';

import {
  Icon as SemanticIcon,
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ showEditContent }) => (showEditContent ? 'space-between;' : 'none')};
  background: ${({ showEditContent }) => (showEditContent ? '#FFFFFF' : '#F1F2F4')};
  margin-bottom: 4px;
  margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : '0px')};
  color: ${({ theme }) => theme.color.textSecondary};
  ${({ showEditContent }) => (showEditContent && 'border: 1px solid #E0E6FF;')};

  &:hover {
    background: ${({ showEditContent }) => (showEditContent ? '#FFFFFF' : '#E0E1E5')};
  }

  ${({ changeBackgroundClickRow }) => changeBackgroundClickRow && '&&& { background: #DCE7FF !important }'}

  ${({ isTester }) => isTester && 'cursor: pointer;'};

  &:focus {
    background: #E0E1E5;
  }
`;

export const ShadowRow = styled.div`
  display: flex;
  height: 5px;
  margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : '0px')};

  ${({ showShadowRow }) => showShadowRow && `
      height: 30px;
      border: 1px dashed #CECECE;
      transition: 0.3s;
  `}
`;

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
`;

export const Button = styled.div`
  border: 1px solid ${({ theme }) => theme.color.textSecondary};
  color: ${({ theme }) => theme.color.textSecondary};
  border-radius: 4px;
  margin-right: 8px;
  padding: 0px 4px 1px 4px;
  cursor: pointer;
  user-select: none;
  background: ${({ theme }) => theme.color.white};
`;

export const Icon = styled(SemanticIcon)`
`;

export const Input = styled(SemanticInput)`
  &&&.ui.fluid.input{
    width: 100%;
  }

  &&&&&&&.ui.input>input {
    padding: 0px 10px 0px 19px;
    border: none;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;

export const ContainerInput = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const ContainerIcon = styled.div`
  min-height: 20px;
`;

export const ContainerLabel = styled.div`
  display: flex;
  align-items: center;
  ${({ hasChild }) => !hasChild && 'padding-left: 20px'}
`;

export const ContainerAction = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-height: ${({ showEditContent }) => (showEditContent ? '28px' : '30px')};
`;

export const ContainerClickable = styled.div`
  display: flex;
  flex: 1;
`;

export const ContainerClickIcon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
`;

export const ButtonTester = styled(ButtonLayoutComponent)`
  &.ui.button {
    min-width: 120px;
    height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const ContainerButtonTester = styled.div`
  position: relative;
  margin-right: -130px;
  margin-left: 10px;
`;
